import React, {Component} from 'react';
import {withRouter} from 'react-router';

import {composeURL} from '../../../utils/url';
import APIList from '../../../containers/APIList';

import RedditItem from './Item';

class RedditList extends Component {

    getURL = (params = {}) => {
        const {
            match: {
                params: {
                    subreddit
                }
            }
        } = this.props;
        return composeURL(
            subreddit
                ? `https://www.reddit.com/r/${subreddit}/.json`
                : `https://www.reddit.com/.json`,
            {
                raw_json: 1,
                ...params
            }
        );
    };

    mapResponseToState = ({
        data: {
            after,
            children
        }
    }) => ({
        items: children.map(({data}) => ({key: data.id, data})),
        url: this.getURL({after})
    });

    shouldComponentUpdate({path}) {
        return path !== this.props.path;
    }

    render() {
        const url = this.getURL();
        return <APIList component={RedditItem} mapResponseToState={this.mapResponseToState} url={url}/>
    }
}

export default withRouter(RedditList);


// WEBPACK FOOTER //
// ./src/portfolio/api/reddit/List.js